// @ts-nocheck
import React, {useEffect, useRef, useState} from 'react';
import Header from '@components/header/Header';
import Verification from '@components/verification/Verification';
import {VerificationType} from '@src/types';
import Product from '@components/product/Product';
import Consumtion from '@components/consumption/Consumtion';
import ProductJourney from '@components/ProductJourney/ProductJourney';
import PageLoader from '@components/PageLoader/PageLoader';
import {fbVerify} from '@api/Verify';
import {getParams, translate} from '@src/helpers';
import bgImage from '@assets/images/bg.png';
import {Translations} from '@constants/translate';
import {useDispatch, useSelector} from 'react-redux';
import {getIP} from '@api/GetIP';
import '@pages/home/home.scss';
import Footer from '@components/footer/Footer';
import {getBrandInfo, getCSS, getRedirect} from '@api/Common';
import {useHistory} from 'react-router-dom';
import {ENV} from "@environments/environment";

const {AWS_S3_FILE_UPLOAD, API_URL, GG_KEY} = ENV


const Home = () => {
    const langData = useSelector((state: any) => state.currentLanguage) as any;
    const dispatch = useDispatch();
    const history = useHistory();

    let params = getParams();

    const [isLoading, setLoading] = useState(true);
    const [isShowEco, setShowEco] = useState(0);
    const [verifyData, setVerifyData] = useState({} as any);
    const [verifyMessage, setVerifyMessage] = useState('');
    const [brandInfo, setBrandInfo] = useState({} as any);
    const [allParams, setAllParams] = useState({...params});

    /**
     * @todo:
     * B2C: always set to 0 after developing
     */
    const tabRef = useRef(params?.tab || 0);
    const removeHostName = (url: any) => {
        const a = document.createElement('a');
        a.href = url;
        return a.search;
    }

    useEffect(() => {
        const getInfo = async () => {
            const IPResult = await getIP() || {};
            if (allParams.shortcode) {
                const {data} = await getRedirect(allParams.shortcode);
                if (data) {
                    history.push(removeHostName(data));
                    setAllParams({...getParams()})
                } else {
                    history.push('/not-found')
                }
            } else {
                if (allParams.brand) {
                    const {data: brandData} = await getBrandInfo(allParams.brand);
                    if (brandData) {
                        setBrandInfo(brandData);
                        dispatch({
                            type: "SET_BRAND_SOCIALS",
                            socials: [...brandData.socials]
                        })
                    }
                    const {data: dataCSS} = await getCSS(allParams.brand);
                    if (dataCSS && dataCSS.css) {
                        const head = document.getElementsByTagName('HEAD')[0];
                        // Create new link Element
                        const link = document.createElement('link');
                        // set the attributes for link element
                        link.rel = 'stylesheet';
                        link.type = 'text/css';
                        link.href = dataCSS.css;
                        // Append link element to HTML head
                        head.appendChild(link);
                    }
                }

                const {data, error, message} = await fbVerify({
                    order: '',
                    brand: '',
                    manufacturer: '',
                    lang: 'en',
                    user_ip: IPResult.ip,
                    country_code: IPResult.country,
                    referrer: document.referrer,
                    ...allParams
                });

                if (error) {
                    const bodyEl = document.querySelector("body");
                    if (bodyEl) {
                        bodyEl.style.backgroundImage = `url(${bgImage})`;
                    }
                    if (error.includes(VerificationType.FAILED.toLowerCase())) {
                        setVerifyData({
                            status: VerificationType.FAILED
                        });
                    }

                    if (error.includes(VerificationType.WARNING.toLowerCase())) {
                        setVerifyData({
                            status: VerificationType.WARNING
                        });
                    }

                    setVerifyMessage(message)
                }

                if (data) {
                    if (data.redirect_url) {
                        window.location = data.redirect_url;
                    }
                    setShowEco(data.eco_visible);
                    const gcData = {} as any;
                    data.product_consumption.gauge_chart.map((item: any) => {
                        const {type, ...rest} = item;
                        gcData[type] = {
                            ...rest
                        }
                        return true;
                    });

                    // group position by manufacturer and
                    let detailed = [] as any;
                    let tempDetail = [];

                    if (data.product_journey_detail_view && data.product_journey_detail_view.length > 1) {
                        data.product_journey_detail_view.sort((a: any, b: any) => a.process_position_b2c - b.process_position_b2c);
                        const dataDetailLenght = data.product_journey_detail_view.length;
                        tempDetail.push(data.product_journey_detail_view[0]);

                        for (let i = 1; i < dataDetailLenght; i++) {
                            if (data.product_journey_detail_view[i].process_manufacturer_name === tempDetail[0].process_manufacturer_name &&
                                data.product_journey_detail_view[i].process_location === tempDetail[0].process_location) {
                                tempDetail.push(data.product_journey_detail_view[i]);
                            } else {
                                detailed.push(tempDetail);
                                tempDetail = [data.product_journey_detail_view[i]];
                            }

                            if (i === dataDetailLenght - 1) {
                                detailed.push(tempDetail);
                            }
                        }
                    } else if (data.product_journey_detail_view && data.product_journey_detail_view.length === 1) {
                        detailed.push([data.product_journey_detail_view[0]]);
                    }

                    setVerifyData({
                        status: VerificationType.VERIFIED,
                        product: {
                            image: data.product_detail && data.product_detail.pic,
                            product_images: data.product_detail && data.product_detail.product_images,
                            status: data.status && data.status.toUpperCase(),
                            message: data.message,
                            name: data.product_detail && data.product_detail.name,
                            company: data.product_detail && data.product_detail.brand_name,
                            companyUrl: data.product_detail && data.product_detail.brand_url,
                            desc: data.product_detail && data.product_detail.description,
                            companyPhone: data.product_detail && data.product_detail.brand_phone,
                            companyEmail: data.product_detail && data.product_detail.brand_email,
                            attributeTemplateValue: data.product_detail && data.product_detail.attributeTemplateValue,
                            claimed_status: data.claimed_status && data.claimed_status.toUpperCase(),
                        },
                        consumtion: {
                            line_chart: data.product_consumption.line_chart,
                            gauge_chart: gcData
                        },
                        map: data.product_journey_map_view,
                        detail: detailed,
                        detailRaw: data.product_journey_detail_view.sort((a: any, b: any) => b.process_position_b2c - a.process_position_b2c),
                    });
                }
                setLoading(false);
            }

        }
        getInfo();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [allParams]);

    return isLoading ? <PageLoader/> : (
        <>
            <Header header={{...brandInfo, isShowEco: isShowEco}}
                    haveMenu={verifyData.status === VerificationType.VERIFIED}/>

            <main>
                {verifyData.status === VerificationType.FAILED &&
                    <Verification type={VerificationType.FAILED}
                                  title={translate(langData.localize, Translations['B2C.VERIFICATION.FAILED'])}
                                  desc={verifyMessage}/>
                }
                {verifyData.status === VerificationType.WARNING &&
                    <Verification type={VerificationType.WARNING}
                                  title={translate(langData.localize, Translations['B2C.VERIFICATION.WARNING'])}
                                  desc={verifyMessage}/>
                }
                {
                    verifyData.status === VerificationType.VERIFIED &&
                    <>
                        <div className={`app-container`}>
                            <div className="pcontainer">
                                <Product {...verifyData.product} id='product'/>
                                <div className="section-2">
                                    {isShowEco === 1 && <Consumtion dataChart={verifyData.consumtion} id='eco-score'/>}
                                    <ProductJourney ref={tabRef}
                                                    dataMap={verifyData.map}
                                                    dataDetail={verifyData.detail}
                                                    dataDetailRaw={verifyData.detailRaw}
                                                    productDetail={verifyData.product}
                                                    id='journey'
                                                    isShowEco={isShowEco}
                                    />
                                </div>
                            </div>
                        </div>
                    </>
                }
            </main>

            <Footer footer={brandInfo}/>
        </>
    );
}

export default Home;
